import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import debounce from "lodash/debounce";
import {
  Alert,
  Icon,
  Layout,
  Table,
  Badge,
  Button,
  Tooltip,
  Switch,
  message,
  Breadcrumb,
  Input,
  Select,
  Checkbox,
  Modal,
} from "antd";

import SettingsConsentForm from "../../components/SettingsConsentForm/SettingsConsentForm";
import classes from "./SettingsConsent.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getConsentRequest,
  deleteConsentRequest,
  activateConsentRequest,
  getSitesRequest,
  getConsentSettingsRequest,
  unApproveConsentRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getConsentCreatePermission,
  getConsentUpdatePermission,
  getConsentDeletePermission,
  getRandomizationAccessPermission,
  getConsentApprovePermission,
  getConsentUnapprovePermission,
} from "../../reducers/user/selectors";
import ConsentApproveForm from "./ConsentApproveForm";
const { Search } = Input;
const { Option } = Select;
const { Content } = Layout;

class SettingsConsent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      consentList: [],
      errorMessage: "",
      responseMessage: "",
      consentEdit: null,
      consentSearch: null,
      filter: "",
      order: "desc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      filtersBy: [],
      filtersOperation: [],
      filtersValue: [],
      site: "",
      workflow_code: "",
      consent_setting_type_code: "",
      consent_template_file_type_code: "",
      sites: [],
      consentSettings: {},
      activeSettings: true,
      approvedSettings: true,
      consentApproveId: null,
    };
  }

  async componentDidMount() {
    this.getConsentList();
    this.getConsentSettingsRequest();
    const { data } = await getSitesRequest();
    this.setState({ sites: data });
  }

  getConsentSettingsRequest = async () => {
    try {
      const { data } = await getConsentSettingsRequest();
      this.setState({
        consentSettings: data,
      });
    } catch (e) {
      console.log(e);
    }
  };

  onConsentSearch = async (value) => {
    this.setState(
      { consentSearch: value, filter: null, site: null, currentPage: 1 },
      this.getConsentList
    );
  };

  getConsentList = debounce(
    async (page = this.state.currentPage, per_page = this.state.pageSize) => {
      this.setState({
        errorMessage: null,
        isLoading: true,
        responseMessage: null,
      });

      try {
        const { data } = await getConsentRequest({
          consentSearch: this.state.consentSearch,
          filter_by: this.state.filter,
          site_code: this.state.site,
          workflow_code: this.state.workflow_code,
          consent_setting_type_code: this.state.consent_setting_type_code,
          consent_template_file_type_code: this.state
            .consent_template_file_type_code,
          // order_direction: this.state.order,
          page,
          per_page,
          order_column: get(this.state, "sortedInfo.columnKey"),
          show_inactive_settings: this.state.activeSettings ? undefined : true,
          filter_approve: this.state.approvedSettings ? true : undefined,
        });
        if (Array.isArray(data.data)) {
          this.setState({
            consentList: data.data,
            total: data.total_pages * per_page,
            currentPage: page,
          });
        } else {
          this.setState({
            consentList: data,
            total: 1 * per_page,
            currentPage: page,
          });
        }
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
          return;
        }
        this.setState({
          subject: null,
          errorMessage: get(e, "response.data.error", "Error"),
        });
      }

      this.setState({ isLoading: false });
    },
    200
  );

  onSwitchConsentApprove = (id, approved) => async () => {
    try {
      if (approved) {
        await unApproveConsentRequest(id);
        this.getConsentList();
        message.success(this.props.i18n.t("Saved"));
      } else {
        this.setState({ consentApproveId: id });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(this.props.i18n.t("Error"));
      console.log(e);
    }
  };

  columns = [
    {
      dataIndex: "name",
      key: "name",
      title: this.props.i18n.t("Name"),
      render: (val, record) => (
        <span>
          <Badge
            count={record.state}
            style={{
              width: "56px",
              backgroundColor: record.state === "active" ? "#52c41a" : "#777",
            }}
          />{" "}
          &nbsp;{val}
        </span>
      ),
    },
    {
      dataIndex: "site",
      key: "site_code",
      title: this.props.i18n.t("Site Code"),
      render: (val) => <span>{get(val, "code")}</span>,
    },
    {
      dataIndex: "site",
      key: "site",
      title: this.props.i18n.t("Site"),
      render: (val) => <span>{get(val, "name")}</span>,
    },
    {
      dataIndex: "applied_to",
      key: "applied_to",
      title: this.props.i18n.t("NamespaceSettingsConsent:Applied to"),
      render: (val) => <span>{val ? val.replace(/_/g, " ") : ""}</span>,
    },
    {
      dataIndex: "consent_workflow_type_readable",
      key: "Workflow_type_readable",
      title: this.props.i18n.t("Consent workflow type"),
      render: (val) => <span>{val}</span>,
    },
    {
      dataIndex: "consent_setting_type_readable",
      key: "consent_setting_type_readable",
      title: this.props.i18n.t("Setting type"),
      render: (val) => <span>{val}</span>,
    },
    {
      dataIndex: "template_file_type_readable",
      key: "template_file_type_readable",
      title: this.props.i18n.t("File type"),
      render: (val) => <span>{val}</span>,
    },

    // these properties will only be evaluated on the UI file type on the backend
    // eventually we will remove the filetype property altogether
    {
      dataIndex: "allow_email_consent",
      key: "allow_email_consent",
      title: this.props.i18n.t("Methods"),
      render: (val, consent) => <span>
        {(consent.template_file_type == 'ui' || consent.template_file_type == 'source') ? (<span>{this.props.i18n.t("Electronic")}

        {consent.allow_email_consent ? (<span>, {this.props.i18n.t("Email")}</span>) : ('')}
        {consent.allow_paper_consent ? (<span>, {this.props.i18n.t("Paper")}</span>) : ('')}</span>)
          : ('(controlled by UI)')}

      </span>,
    },
    {
      dataIndex: "consent_version",
      key: "consent_version",
      title: this.props.i18n.t("Consent version"),
      render: (val) => <span>{val}</span>,
    },
    {
      dataIndex: "id",
      key: "id",
      title: this.props.i18n.t("Actions"),
      render: (id, consent) => (
        <div className={classes.actions}>
          <Tooltip
            placement="topLeft"
            title={this.props.i18n.t("NamespaceSettingsConsent:Edit Consent")}
          >
            <Icon
              type="edit"
              theme="filled"
              className={classes.actionIcon}
              onClick={this.onConsentEdit(consent)}
            />
          </Tooltip>
          <div style={{ margin: "0 0 0 10px" }}>
            <span>Activate</span>
            <br />
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t(
                "NamespaceSettingsConsent:Activate / Deactivate Consent"
              )}
            >
              <Switch
                disabled={
                  (consent.state === "active" &&
                    !this.props.consentDeletePermission) ||
                  (consent.state === "inactive" &&
                    !this.props.consentUpdatePermission)
                }
                className={classes.activateBtn}
                checked={consent.state === "active"}
                onChange={this.onSwitchConsentActivation(id, consent.state)}
              />
            </Tooltip>
          </div>
          &nbsp; &nbsp;
          {consent.state === "active" &&
            ((this.props.consentApprovePermission && !consent.approved) ||
              (this.props.consentUnapprovePermission && consent.approved)) && (
              <div>
                <span className={classes.switchLabel}>
                  {this.props.i18n.t("Approve")}
                </span>
                <br />
                <Tooltip
                  placement="topLeft"
                  title={this.props.i18n.t("Approve / Unapprove Consent")}
                >
                  <Switch
                    className={classes.reactivateBtn}
                    checked={consent.approved}
                    onChange={this.onSwitchConsentApprove(id, consent.approved)}
                  />
                </Tooltip>
              </div>
            )}
        </div>
      ),
    },
  ];

  onSwitchConsentActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deleteConsentRequest(id);
      } else {
        await activateConsentRequest(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.getConsentList();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.error", "Error"));
    }
  };

  onConsentEdit = (consent) => () => {
    this.setState({ consentEdit: consent });
  };

  onConsentEditHide = () => {
    this.setState({ consentEdit: null });
  };

  onConsentEditSubmit = () => {
    this.setState({ consentEdit: null }, this.getConsentList);
  };

  addConsent = () => {
    this.setState({ consentEdit: {} });
  };

  onConsentSearchChange = (e) => {
    this.setState({ consentSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getConsentList(pagination.current, pagination.pageSize)
    );
  };

  clearFilters = () => {
    this.setState(
      {
        subjectSearch: null,
        site: null,
        workflow_code: null,
        consent_setting_type_code: null,
        consent_template_file_type_code: null,
        filter: null,
        eventsSelected: {},
        sortedInfo: null,
        currentPage: 1,
      },
      this.getConsentList
    );
  };

  handleSiteChange = (value) => {
    this.setState(
      { site: value, sortedInfo: null, currentPage: 1 },
      this.getConsentList
    );
  };

  handleFilterChange = (value) => {
    this.setState(
      {
        filter: value,
        site: null,
        workflow_code: null,
        consent_setting_type_code: null,
        consent_template_file_type_code: null,
        eventsSelected: {},
        subjectSearch: null,
        sortedInfo: null,
      },
      this.getSubjects
    );
  };

  render() {
    const {
      consentList,
      errorMessage,
      responseMessage,
      isLoading,
      consentEdit,
      consentSearch,
      currentPage,
      total,
      pageSize,
      site,
      sites,
      filter,
      activeSettings,
      consentSettings,
      workflow_code,
      consent_setting_type_code,
      consent_template_file_type_code,
      consentApproveId,
      approvedSettings,
    } = this.state;

    const { consentCreatePermission } = this.props;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceSettingsConsent:Consent Management")}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/admin/consent/editor">
                {this.props.i18n.t(
                  "NamespaceSettingsConsent:Consent Management"
                )}
              </Breadcrumb.Item>
              {consentEdit && (
                <Breadcrumb.Item>
                  {this.props.i18n.t("NamespaceSettingsConsent:Edit")}
                </Breadcrumb.Item>
              )}
            </Breadcrumb>
            <br />

            {!consentEdit && (
              <div>
                <div className={classes.searchWrapper}>
                  <label className={classes.searchWrapperSearch}>
                    <b className={classes.searchWrapperLabel}>
                      {this.props.i18n.t("SEARCH")}
                    </b>
                    <Search
                      placeholder={this.props.i18n.t(
                        "NamespaceSettingsConsent:By name"
                      )}
                      enterButton={this.props.i18n.t("Search")}
                      size="large"
                      onSearch={this.onConsentSearch}
                      value={consentSearch}
                      onChange={this.onConsentSearchChange}
                      style={{ maxWidth: "500px" }}
                    />
                  </label>

                  <div className={classes.searchWrapperFilter}>
                    <label className={classes.searchWrapperFilterItem}>
                      <b className={classes.searchWrapperLabel}>
                        {this.props.i18n.t("Filter by")}
                      </b>
                      <Select
                        onChange={this.handleFilterChange}
                        value={filter}
                        style={{ width: "100%" }}
                        placeholder={this.props.i18n.t("Select")}
                      >
                        <Option value="site">
                          {this.props.i18n.t("Site")}
                        </Option>
                        <Option value="workflow">
                          {this.props.i18n.t("Workflow")}
                        </Option>
                        <Option value="consent_setting_type">
                          {this.props.i18n.t("Consent setting type")}
                        </Option>
                        <Option value="consent_template_file_type">
                          {this.props.i18n.t("Consent template file type")}
                        </Option>
                      </Select>
                    </label>

                    {filter === "site" && (
                      <label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>
                          {this.props.i18n.t("Site")}
                        </b>
                        <Select
                          onChange={this.handleSiteChange}
                          value={site}
                          showSearch
                          optionFilterProp="children"
                          filterOption
                          style={{ width: "100%" }}
                          placeholder={this.props.i18n.t("Select")}
                        >
                          {sites
                            .sort((a, b) => a.code - b.code)
                            .map((site) => (
                              <Option key={site.id} value={site.code}>
                                {site.code} - {site.name}
                              </Option>
                            ))}
                          <Option value="">
                            {this.props.i18n.t("All sites")}
                          </Option>
                        </Select>
                      </label>
                    )}

                    {filter === "workflow" && (
                      <label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>
                          {this.props.i18n.t("Workflow")}
                        </b>
                        <Select
                          onChange={(value) => {
                            this.setState(
                              {
                                workflow_code: value,
                                sortedInfo: null,
                                currentPage: 1,
                              },
                              this.getConsentList
                            );
                          }}
                          value={workflow_code}
                          showSearch
                          optionFilterProp="children"
                          filterOption
                          style={{ width: "100%" }}
                          placeholder={this.props.i18n.t("Select")}
                        >
                          {get(consentSettings, "workflow_type", []).map(
                            (item) => (
                              <Option key={item.id} value={item.value}>
                                {item.name}
                              </Option>
                            )
                          )}
                          <Option value="">
                            {this.props.i18n.t("All workflows")}
                          </Option>
                        </Select>
                      </label>
                    )}

                    {filter === "consent_setting_type" && (
                      <label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>
                          {this.props.i18n.t("Consent setting type")}
                        </b>
                        <Select
                          onChange={(value) => {
                            this.setState(
                              {
                                consent_setting_type_code: value,
                                sortedInfo: null,
                                currentPage: 1,
                              },
                              this.getConsentList
                            );
                          }}
                          value={consent_setting_type_code}
                          showSearch
                          optionFilterProp="children"
                          filterOption
                          style={{ width: "100%" }}
                          placeholder={this.props.i18n.t("Select")}
                        >
                          {get(consentSettings, "consent_setting_type", []).map(
                            (item) => (
                              <Option key={item.id} value={item.value}>
                                {item.name}
                              </Option>
                            )
                          )}
                          <Option value="">
                            {this.props.i18n.t("All types")}
                          </Option>
                        </Select>
                      </label>
                    )}

                    {filter === "consent_template_file_type" && (
                      <label className={classes.searchWrapperFilterItem}>
                        <b className={classes.searchWrapperLabel}>
                          {this.props.i18n.t("Consent setting type")}
                        </b>
                        <Select
                          onChange={(value) => {
                            this.setState(
                              {
                                consent_template_file_type_code: value,
                                sortedInfo: null,
                                currentPage: 1,
                              },
                              this.getConsentList
                            );
                          }}
                          value={consent_template_file_type_code}
                          showSearch
                          optionFilterProp="children"
                          filterOption
                          style={{ width: "100%" }}
                          placeholder={this.props.i18n.t("Select")}
                        >
                          {get(
                            consentSettings,
                            "consent_template_file_type",
                            []
                          ).map((item) => (
                            <Option key={item.id} value={item.value}>
                              {item.name}
                            </Option>
                          ))}
                          <Option value="">
                            {this.props.i18n.t("All types")}
                          </Option>
                        </Select>
                      </label>
                    )}
                  </div>

                  <span
                    className={classes.clearButton}
                    onClick={this.clearFilters}
                  >
                    {this.props.i18n.t("Clear")}
                  </span>
                </div>

                <div style={{ margin: "0" }}>
                  <Checkbox
                    onChange={(e) => {
                      this.setState(
                        { activeSettings: e.target.checked, currentPage: 1 },
                        this.getConsentList
                      );
                    }}
                    checked={activeSettings === null || activeSettings === true}
                    style={{ margin: "0 0 20px" }}
                  >
                    {this.props.i18n.t("NamespaceSettingsConsent:Active")}
                  </Checkbox>

                  <Checkbox
                    onChange={(e) => {
                      this.setState(
                        { approvedSettings: e.target.checked, currentPage: 1 },
                        this.getConsentList
                      );
                    }}
                    checked={
                      approvedSettings === null || approvedSettings === true
                    }
                    style={{ margin: "0 15px 20px" }}
                  >
                    {this.props.i18n.t("NamespaceSettingsConsent:Approved")}
                  </Checkbox>
                </div>

                {errorMessage && <Alert type="error" message={errorMessage} />}

                {responseMessage && (
                  <Alert type="success" message={responseMessage} />
                )}

                {consentCreatePermission && (
                  <div>
                    <Button type="primary" onClick={this.addConsent}>
                      {this.props.i18n.t(
                        "NamespaceSettingsConsent:Add consent"
                      )}
                    </Button>
                    <br />
                    <br />
                  </div>
                )}

                <div className={classes.tableWrapper}>
                  <Table
                    columns={this.columns}
                    dataSource={consentList}
                    loading={isLoading}
                    rowKey="id"
                    onChange={this.handleTableChange}
                    pagination={{
                      onShowSizeChange: (current, size) => {
                        this.setState({ pageSize: size });
                      },
                      current: currentPage,
                      total,
                      pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "25", "50", "100"],
                      position: 'both',
                    }}
                  />
                </div>
              </div>
            )}

            {consentEdit && (
              <SettingsConsentForm
                {...consentEdit}
                consentSettings={consentSettings}
                isNew={consentEdit && !consentEdit.id}
                onSubmit={this.onConsentEditSubmit}
                onCancel={this.onConsentEditHide}
              />
            )}

            <Modal
              visible={!!consentApproveId}
              onCancel={() => {
                this.setState({ consentApproveId: null });
              }}
              footer={null}
            >
              {consentApproveId && (
                <ConsentApproveForm
                  id={consentApproveId}
                  onSubmit={() => {
                    this.setState(
                      { consentApproveId: null, currentPage: 1 },
                      this.getConsentList
                    );
                  }}
                  onCancel={() => {
                    this.setState({ consentApproveId: null });
                  }}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consentCreatePermission: getConsentCreatePermission(state),
  consentUpdatePermission: getConsentUpdatePermission(state),
  consentDeletePermission: getConsentDeletePermission(state),
  randomizationAccessPermission: getRandomizationAccessPermission(state),
  consentApprovePermission: getConsentApprovePermission(state),
  consentUnapprovePermission: getConsentUnapprovePermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsConsent))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsConsent/SettingsConsent.js